import { CatBadge, CatIconTagFilled } from 'components/blocks-components';
import cx from 'classnames';
import { Conditional } from '@cat-ecom/pcc-components';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import styles from './specials-badge.module.scss';

interface SpecialsBadgeProps {
  className: string;
  specials: Specials[];
}

const SpecialsBadge = ({ className, specials = [] }: SpecialsBadgeProps) => {
  const hasSpecials = !isEmpty(specials);
  const [{ name } = { name: '' }] = specials;

  return (
    <Conditional test={hasSpecials}>
      <CatBadge
        text={name}
        variant="yellow"
        className={cx(styles['specials-badge'], className)}
        data-testid="specials-badge"
      >
        <CatIconTagFilled slot="before" data-testid="specials-icon-tag" />
      </CatBadge>
    </Conditional>
  );
};

export default SpecialsBadge;
